import { gql } from '@apollo/client';
import BaseService from './baseService';
import contactMethodsService from './contactMethodsService';
import phoneTypesService from './phoneTypesService';
import addressTypesService from './addressTypesService';
import RESTAddressTypesService from './RESTAddressTypesService';
import dispatchWorkflowService from './dispatchWorkflowService';
import dispatchStatesService from './dispatchStatesService';
import dispatchContactTypesService from './dispatchContactTypesService';

const restAddressTypesService = new RESTAddressTypesService();

class BaseDataService extends BaseService {
  constructor() {
    super();
  }

  async getBaseData() {
    const query = gql`
      query {
        companyAddressTypes {
          addressTypeId
          addressType
        }
        phoneTypes {
          phoneTypeId
          phoneType
        }
        companyPhoneTypes {
          phoneTypeId
          phoneType
        }
        contactMethods {
          preferredContactMethodId
          method
        }
        companyContactMethods {
          preferredContactMethodId
          contactMethod
        } 
        dispatchWorkflowTypes {
          workflowTypeId
          workflowType
        }
        dispatchStates {
          stateId
          statusId
          status
          state
          order
        }
        dispatchContactTypes {
          contactTypeId
          contactType
        }
        dispatchWorkflowComponents {
          workflowComponentId
          componentName
          shortDescription
          description
        }
      }
    `;

    const result = await this.client.query({
      query,
      fetchPolicy: 'cache-first'
    });

    const resultData = {
      ...result.data
    };

    // We need to ensure that the data is fetched from the services
    // if it is not already present in the result we need to fetch it from the services.
    const servicesMap = {
      addressTypes: () => restAddressTypesService.getAddressTypes(),
      companyAddressTypes: addressTypesService.getClientAddressTypes,
      phoneTypes: phoneTypesService.getPhoneTypes,
      companyPhoneTypes: phoneTypesService.getClientPhoneTypes,
      contactMethods: contactMethodsService.getContactMethods,
      companyContactMethods: contactMethodsService.getClientContactMethods,
      dispatchWorkflowTypes: dispatchWorkflowService.getDispatchWorkflowTypes,
      dispatchStates: dispatchStatesService.getDispatchStates,
      dispatchContactTypes: dispatchContactTypesService.getContactTypes,
      dispatchWorkflowComponents: dispatchWorkflowService.getDispatchWorkflowComponents,
    };

    const missingKeys = Object.keys(servicesMap).filter((key) => !resultData[key]);

    await Promise.all(missingKeys.map(async (key) => {
      const serviceMethod = servicesMap[key];
      const fetchedData = await serviceMethod();
      if (!fetchedData) {
        throw new Error(`Failed to fetch data for ${key}`);
      }
      resultData[key] = fetchedData;
    }));

    return resultData;
  }
}

const baseDataService = new BaseDataService();

export default baseDataService;
